import { render } from "./ChatDetail.vue?vue&type=template&id=81c17b8e"
import script from "./ChatDetail.vue?vue&type=script&lang=js"
export * from "./ChatDetail.vue?vue&type=script&lang=js"

import "./ChatDetail.vue?vue&type=style&index=0&id=81c17b8e&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__